
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component({
  name: 'MsgNewNotice',
})
class MsgNewNotice extends Vue {
  @Prop({ default: 0 }) nums: number | undefined;
  isShow: boolean = false;
  unreadTimer: any = null;

  // 有未读消息时不要立即显示，否则会闪一下又因为滚动而消失
  @Watch('nums')
  onNumChange(val) {
    console.log('[unreadMsgNum]', val);
    if (val - 0 > 0) {
      this.unreadTimer = setTimeout(() => {
        this.isShow = true;
      }, 1000);
    } else {
      clearTimeout(this.unreadTimer);
      this.isShow = false;
    }
  }
}
export default MsgNewNotice;
